import { LogViewer } from '../components/admin/LogViewer';

export function AdminLogs() {
  return <LogViewer />;
}
